import z from "zod";

export const getAcknowledgementDefinitionParamSchema = z.object({
	acknowledgementDefinitionId: z.uuid(),
});

export type GetAcknowledgementDefinitionParamSchema = z.infer<
	typeof getAcknowledgementDefinitionParamSchema
>;
